/* KOUNOU トップページの最小限のUI挙動

   やることは2つだけ。
     1. スクロールに合わせて要素を出現させる（.reveal → .is-visible）
     2. ヒーローを抜けたらヘッダーに地色を付ける

   どちらも IntersectionObserver で行い、scroll イベントは使わない。
   scroll は発火回数が多く、スクロールのたびにレイアウト計算が走るため。

   JSが動かない環境でも内容が消えないよう、CSS側は html.js が付いている
   ときだけ .reveal を隠す設計にしている。だから最初に html.js を付ける。 */

(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.add('js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. スクロールで出現 ---------- */

  function revealAll() {
    var els = document.querySelectorAll('.reveal');
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-visible');
  }

  if (!('IntersectionObserver' in window) || reduceMotion) {
    // 非対応環境・動きを減らす設定では、最初から全て見えている状態にする
    revealAll();
  } else {
    var revealFired = false;

    var revealObserver = new IntersectionObserver(
      function (entries) {
        revealFired = true;
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          // 画面に入ったとき、または既に画面より上へ通り過ぎているときに出す。
          // 上へ通り過ぎた場合を拾わないと、アンカーで途中へ飛んだときに
          // 飛び越えたセクションが透明なまま残る。
          if (!e.isIntersecting && e.boundingClientRect.top >= 0) continue;
          e.target.classList.add('is-visible');
          // 一度出したら監視をやめる。戻ったときに再度消えると鬱陶しいため。
          revealObserver.unobserve(e.target);
        }
      },
      // 要素の上端が画面下から12%入った時点で出す。
      // 画面に完全に入るまで待つと、出現が遅れて見える。
      { rootMargin: '0px 0px -12% 0px', threshold: 0 }
    );

    var targets = document.querySelectorAll('.reveal');
    for (var j = 0; j < targets.length; j++) revealObserver.observe(targets[j]);

    /* フェイルセーフ。
       出現演出は飾りだが、動かなかったときに本文が消えるのは事故になる。
       2秒経っても一度も発火していなければ observer が機能していないと見なし、
       全て表示する。内容が読めない状態を絶対に残さない。 */
    setTimeout(function () {
      if (!revealFired) revealAll();
    }, 2000);
  }

  /* ---------- 2. ヘッダーの地色 ----------
     既定は地色あり。ヒーローに重なっている間だけ .is-over-hero を付けて透過にする。
     この向きにするのは、JSが動かなかったときに
     白いロゴが白い背景に置かれて消えるのを防ぐため。

     ヒーロー自体を監視すると「少しでも見えていれば透過」になり、
     ヒーロー末尾で文字が読めなくなる。ヘッダーの高さぶんだけの
     見張り役（sentinel）を置き、それが画面内かどうかで判定する。 */

  var header = document.querySelector('.ko-header');
  var hero = document.querySelector('.ko-hero');

  if (header && hero && 'IntersectionObserver' in window) {
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText =
      'position:absolute;top:0;left:0;width:1px;height:' + header.offsetHeight + 'px;pointer-events:none;';
    hero.appendChild(sentinel);

    // 初期状態を同期的に判定する。observer の初回発火を待つと
    // 読み込み直後の一瞬だけヘッダーに地色が出てちらつく。
    // 無条件に付けるのは避ける。observer が動かなかった場合に
    // 「透過のまま」で固定され、地色なしの危険な側へ倒れるため。
    header.classList.toggle('is-over-hero', sentinel.getBoundingClientRect().bottom > 0);

    new IntersectionObserver(
      function (entries) {
        header.classList.toggle('is-over-hero', entries[0].isIntersecting);
      },
      { threshold: 0 }
    ).observe(sentinel);
  }

  /* ---------- 3. スマホ下部固定CTAバー ----------
     ヒーローを抜けたら出し、購入導線そのもの（プラン選択・クロージング）が
     画面に入ったら消す。目の前に本物のCTAがあるのに固定バーを重ねると、
     どちらを押せばよいのか分からなくなるため。

     既定は非表示なので、JSが動かなくてもバーが出ないだけで害はない。 */

  var bar = document.getElementById('ko-sticky-cta');

  if (bar && hero && 'IntersectionObserver' in window) {
    bar.hidden = false;

    var pastHero = false;
    var overCta = 0;

    function syncBar() {
      bar.classList.toggle('is-shown', pastHero && overCta === 0);
    }

    // ヒーローを抜けたかどうか
    new IntersectionObserver(
      function (entries) {
        pastHero = !entries[0].isIntersecting;
        syncBar();
      },
      { threshold: 0 }
    ).observe(hero);

    // 購入導線が画面に入っているかどうか。複数を同時に監視し、
    // 1つでも見えていればバーを引っ込める。
    var ctaSections = document.querySelectorAll('#ko-plans, #ko-closing');

    if (ctaSections.length) {
      var ctaObserver = new IntersectionObserver(
        function (entries) {
          for (var k = 0; k < entries.length; k++) {
            entries[k].target.dataset.koVisible = entries[k].isIntersecting ? '1' : '';
          }
          overCta = document.querySelectorAll('[data-ko-visible="1"]').length;
          syncBar();
        },
        { threshold: 0 }
      );
      for (var n = 0; n < ctaSections.length; n++) ctaObserver.observe(ctaSections[n]);
    }
  }

  /* ---------- 4. 光沢の着火 ----------
     「プランを選ぶ」ボタンと、強調しているプランカードの枠を光らせる。
     画面に入ったときに .is-lit を付け、そこから0.5秒後に着火して
     1.5秒ごとに一度光る（間隔はCSS側で定義）。

     画面外のものを回し続けないよう、入ったときだけ点ける。
     一度点けたら消さない。スクロールで出入りするたびに
     0.5秒の待ちが再発すると、光り方が不規則に見えるため。 */

  var lightables = document.querySelectorAll('.ko-btn--shine, .ko-plans__item.is-highlight');

  if (lightables.length && 'IntersectionObserver' in window && !reduceMotion) {
    var lightObserver = new IntersectionObserver(
      function (entries) {
        for (var q = 0; q < entries.length; q++) {
          if (!entries[q].isIntersecting) continue;
          entries[q].target.classList.add('is-lit');
          lightObserver.unobserve(entries[q].target);
        }
      },
      { threshold: 0 }
    );
    for (var m = 0; m < lightables.length; m++) lightObserver.observe(lightables[m]);
  }
})();
